import { Formatter, setData, useApiCallback, useSelector } from "gf-ui";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Button, Container, Form, Modal } from "react-bootstrap";
import { FaCheck } from "react-icons/fa";
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { annullaRisposteDipendenze, PAGINE, TIPOLOGIE, validateEmail } from ".";
import apiQuestionario from "../api/apiQuestionario";
import Footer from "../components/Footer";
import InputDate from "../components/InputDate";
import InputEmail from "../components/InputEmail";
import InputNumber from "../components/InputNumber";
import InputText from "../components/InputText";
import Select from "../components/Select";
import Telefono from "../components/Telefono";
import { MODULO_ANAMNESTICO, TIPI_RISPOSTE } from "../constants";
import HeaderColon from "./coloneRetto/components/HeaderColon";
import HeaderSenologia from "./senologia/components/HeaderSenologia";
import HeaderTicketPsStranieri from "./ticketPsStranieri/components/HeaderTicketPsStranieri";
import PageContainer from "../components/PageContainer";


const ModuloAnamnestico = ({ tipologia }) => {
    const pageData = useSelector(state => state.page.data)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const apiCallback = useApiCallback()
    const _apiQuestionario = useRef(new apiQuestionario(dispatch, apiCallback, null))
    _apiQuestionario.current.setFixedParams({ ID_TIPOLOGIA: tipologia.KID })
    const [scheda, setScheda] = useState(null)
    const [confirmCancel, setConfirmCancel] = useState(false)
    const [domande, setDomande] = useState({});
    const [risposte, setRisposte] = useState([])
    const [telefono, setTelefono] = useState("")    
    const [email, setEmail] = useState("")
    const [privacy, setPrivacy] = useState(false)
    const shouldInit = useRef(true)    

    const header = useMemo(() => {
        if (tipologia) {
            switch (tipologia.KID) {
                case TIPOLOGIE.SENOLOGIA.KID: return <HeaderSenologia subtitle={`Compila il modulo Anamnestico, e clicca su "Ho Terminato" una volta finito`} />;
                case TIPOLOGIE.COLON_RETTO.KID: return <HeaderColon subtitle={`Compila il modulo Anamnestico sul Colon Retto, e clicca su "Ho Terminato" una volta finito`} />;
                case TIPOLOGIE.TICKET_PS_STRANIERI.KID: return <HeaderTicketPsStranieri subtitle={`Compila il modulo`} />;
                default: return
            }
        }
    }, [tipologia])

    const idModello = useMemo(() => {
        if (tipologia) {
            switch (tipologia.KID) {
                case TIPOLOGIE.SENOLOGIA.KID: return MODULO_ANAMNESTICO.SENOLOGIA;
                case TIPOLOGIE.COLON_RETTO.KID: return MODULO_ANAMNESTICO.COLON_RETTO;
                case TIPOLOGIE.TICKET_PS_STRANIERI.KID: return MODULO_ANAMNESTICO.TICKET_PS_STRANIERI;
                default: return;
            }
        }
    }, [tipologia])

    const onChangeSelect = (kid, val) => {
        let dom = domande;
        let newVal = dom[kid];

        newVal.ARR_RISPOSTE.forEach((item, index) => {
            if (parseInt(item.ID_MA_CSS_D_R) === parseInt(val)) {
                newVal.ARR_RISPOSTE[index].FLG_SELEZIONATA = '-1';
            } else {
                newVal.ARR_RISPOSTE[index].FLG_SELEZIONATA = '0';
            }
        })

        newVal.val = val;

        dom = {
            ...dom,
            [kid]: newVal
        }

        annullaRisposteDipendenze(dom)

        setDomande({ ...dom });
    }

    const onChangeInputNumber = (kid, val) => {

        //replace non-digits with blank
        val = val.replace(/[^\d]/, '');
        if (isNaN(parseInt(val))) {
            val = "";
        }

        let dom = domande;
        let newVal = dom[kid];
        newVal.ARR_RISPOSTE[0].VALORE = val;
        newVal.val = val;
        dom = {
            ...dom,
            [kid]: newVal
        }
        annullaRisposteDipendenze(dom)
        setDomande({ ...dom });
    }


    const onChangeInputText = (kid, val) => {
        let dom = domande;
        let newVal = dom[kid];
        newVal.ARR_RISPOSTE[0].VALORE = val;
        newVal.val = val;
        dom = {
            ...dom,
            [kid]: newVal
        }
        annullaRisposteDipendenze(dom)
        setDomande({ ...dom });
    }

    const elencoDomande = useCallback(() => {
        const params = {
            ID_MODELLO: idModello,
            LINGUA: pageData.LINGUA
        }

        _apiQuestionario.current.fnGetDomande(res => {
            setScheda(res.scheda)
            setData(dispatch, {...pageData, ETICHETTE: res.etichette })
        }, params, () => navigate(`/${tipologia.URL}`))
    }, [dispatch, idModello, navigate, pageData, tipologia.URL])

    const salvaRisposte = (e) => {
        e.preventDefault();

        if (!Formatter.isStringaVuota(email) && !validateEmail(email)) {
            return
        }

        const params = {
            SCHEDA: JSON.stringify(scheda),
            ID_MODELLO: idModello,
            TELEFONO: telefono,
            EMAIL: email,
            FLG_PRIVACY_ACCETTATA: privacy ? "-1" : "0",
            LINGUA: pageData.LINGUA
        }

        _apiQuestionario.current.fnSalvaRisposte(res => {
            navigate(`/${tipologia.URL}${PAGINE.RISULTATO.URL}`, { state: res })
        }, params)
    }

    const annulla = () => {
        setScheda(null)
        navigate(`/${tipologia.URL}`)
    }

    useEffect(() => {
        if (scheda) {
            let elenco_domande = {};
            scheda?.EN_MODELLO?.ARR_DOMANDE?.forEach((item, index) => {
                elenco_domande[index] = item;
            })
            setDomande(elenco_domande)
        }
    }, [scheda])

    useEffect(() => {
        if (shouldInit.current) {
            shouldInit.current = false;
            elencoDomande()
        }
    }, [elencoDomande])

    useEffect(() => {
        let ris = [];
        Object.keys(domande).forEach(id_domanda => {
            if (domande[id_domanda].val) {
                ris.push(domande[id_domanda].val)
            }
        })
        setRisposte(ris)
    }, [domande])

    return <PageContainer tipologia={tipologia} className="modulo-anamnestico-container">
        <Container className={`modulo-anamnestico bg-white p-0 rounded overflow-hidden`}>
            {header}            

            <Form onSubmit={(e) => salvaRisposte(e)}>

                {Object.keys(domande).map((kid, index) => {
                    const domanda = domande[kid];
                    switch (domanda.TIPO_RISPOSTA) {
                        case TIPI_RISPOSTE.COMBO:
                            return (
                                <Select key={index}
                                    kid={kid}
                                    domanda={domanda.DESCRIZIONE}
                                    domande={domande}
                                    risposte={domanda.ARR_RISPOSTE}
                                    mostraSe={domanda.ARR_RIFERIMENTI}
                                    value={domanda.val}
                                    onChange={onChangeSelect} />
                            );
                        case TIPI_RISPOSTE.NUMERO:
                            return (
                                <InputNumber key={index}
                                    kid={kid}
                                    domanda={domanda.DESCRIZIONE}
                                    domande={domande}
                                    mostraSe={domanda.ARR_RIFERIMENTI}
                                    value={domanda.val || ""}
                                    placeholder={domanda.ARR_RISPOSTE[0].DESCRIZIONE}
                                    onChange={onChangeInputNumber} />
                            )
                        case TIPI_RISPOSTE.TESTO:
                            return (
                                <InputText key={index}
                                    kid={kid}
                                    domanda={domanda.DESCRIZIONE}
                                    domande={domande}
                                    mostraSe={domanda.ARR_RIFERIMENTI}
                                    value={domanda.val || ""}
                                    placeholder={domanda.ARR_RISPOSTE[0].DESCRIZIONE}
                                    onChange={onChangeInputText} />
                            )
                        case TIPI_RISPOSTE.EMAIL:
                            return (
                                <InputEmail key={index}
                                    kid={kid}
                                    domanda={domanda.DESCRIZIONE}
                                    domande={domande}
                                    mostraSe={domanda.ARR_RIFERIMENTI}
                                    value={domanda.val || ""}
                                    placeholder={domanda.ARR_RISPOSTE[0].DESCRIZIONE}
                                    onChange={onChangeInputText} />
                            )
                        case TIPI_RISPOSTE.DATA:
                            return (
                                <InputDate key={index}
                                    kid={kid}
                                    domanda={domanda.DESCRIZIONE}
                                    domande={domande}
                                    mostraSe={domanda.ARR_RIFERIMENTI}
                                    value={domanda.val || ""}
                                    placeholder={domanda.ARR_RISPOSTE[0].DESCRIZIONE}
                                    onChange={onChangeInputText} />
                            )
                        default:
                            return null;
                    }
                })
                }

                {Formatter.getBoolean(scheda?.EN_MODELLO?.FLG_RICHIEDI_EMAIL_TEL) && (
                    <div className="mb-3 form-group">
                        <Telefono
                            telefono={telefono}
                            onChangeTelefono={(val) => setTelefono(val)}
                            email={email}
                            onChangeEmail={(val) => setEmail(val)}
                            privacy={privacy}
                            onChangePrivacy={(val) => setPrivacy(val)}
                        />
                    </div>
                )}

                <Form.Group className="mb-3 form-group">
                    <div className="d-grid gap-2 m-2">
                        <Button type="button" variant="outline-secondary" className="btn-lg" onClick={() => setConfirmCancel(true)}>{pageData?.ETICHETTE?.annulla?.toUpperCase()}</Button>
                        {risposte.length > 0 && (
                            <Button type="submit" variant="success" className="btn-lg"><strong style={{ fontSize: '2rem' }}><FaCheck /><span className="ms-2">{pageData?.ETICHETTE?.ho_terminato?.toUpperCase()}</span></strong></Button>
                        )}
                    </div>
                </Form.Group>

                <Footer tipologia={tipologia} />

                <Modal show={confirmCancel} className="d-flex modal-dialog-centered">
                    <Modal.Body className="text-center modal-loading">
                        <h1 style={{ color: 'steelblue' }}>{pageData?.ETICHETTE?.vuoi_uscire}</h1>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-secondary" onClick={() => setConfirmCancel(false)}>{pageData?.ETICHETTE?.annulla}</Button>
                        <Button variant="primary" onClick={annulla} className="text-light">{pageData?.ETICHETTE?.conferma}</Button>
                    </Modal.Footer>
                </Modal>
            </Form>
        </Container>
    </PageContainer>
}

export default ModuloAnamnestico;
